import React from "react";

import { ListingPicker } from "./ListingPicker";
import { SymbolExchangeRow } from "./SymbolExchangeRow";
import { ListingFieldsProps } from "./types";

export const ListingFields: React.FC<ListingFieldsProps> = ({
  control,
  disabled,
  ...picker
}) => (
  <>
    <SymbolExchangeRow control={control} disabled={disabled} />
    <ListingPicker control={control} disabled={disabled} {...picker} />
  </>
);
